import type { Route } from './+types/route';

export const handle: { scripts: (args: Route.MetaArgs) => any } = {
  scripts: ({ matches: [_root, dynamicRoute] }) => dynamicRoute.data.componentScripts,
};
